import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { ReactComponent as ArrowIcon } from "./arrow.svg";

const translationNamespace = "common/BackArrowButton";

type BackArrowButtonProps = {
  onClick?: () => void;
};

export const BackArrowButton: React.FC<BackArrowButtonProps> = ({
  onClick,
}) => {
  const classes = createBackArrowButtonStyles();
  const history = useHistory();
  const { t } = useTranslation(translationNamespace);
  return (
    <button
      onClick={() => {
        onClick ? onClick() : history.goBack();
      }}
      className={classes.navButton}
      title={t("Go back")}
    >
      <ArrowIcon />
    </button>
  );
};

function createBackArrowButtonStyles() {
  return {
    navButton: css({
      appearance: "none",
      background: "transparent",
      border: "none",
      cursor: "pointer",
      padding: 0,
    }),
  };
}
